export function createReduxRestHandlerMiddleware(dispatch) {
  return (middlewareApi) => (next) => (response) => {
    if (!response) return next();
    if (response.ok) return next(response);

    if (response.status !== 401) {
      console.log(response.statusText);
    }
    return next(response);
  };
}
